import { motion } from "framer-motion";
import { ShieldCheck, Award, BadgeCheck, Wrench, Landmark, Radar } from "lucide-react";

const badges = [
  { icon: Award, label: "Swissolar-Fachpartner" },
  { icon: ShieldCheck, label: "25 Jahre Modulgarantie" },
  { icon: Wrench, label: "10 Jahre Vollgarantie auf Montage" },
  { icon: Landmark, label: "Pronovo-Förderung inklusive" },
  { icon: BadgeCheck, label: "Schweizer Fachpersonal" },
  { icon: Radar, label: "24/7 Anlagen-Monitoring" },
];

/**
 * Bildband unter dem Hero: echtes Anlagenfoto plus laufende Vertrauens-Leiste.
 */
export default function Showcase() {
  return (
    <section data-testid="showcase-section" className="relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.figure
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="relative rounded-[28px] overflow-hidden img-placeholder"
        >
          <img
            src="/images/hero-haus.webp"
            alt="Schweizer Einfamilienhaus mit Holzfassade und vollflächiger schwarzer Photovoltaik-Anlage vor Alpenpanorama"
            width="1800"
            height="1005"
            decoding="async"
            fetchPriority="high"
            className="w-full h-[300px] sm:h-[400px] lg:h-[520px] object-cover"
          />

          <div className="absolute inset-0 bg-gradient-to-t from-[#1A1D20]/90 via-[#1A1D20]/25 to-transparent" />

          <figcaption className="absolute inset-x-0 bottom-0 p-6 md:p-10">
            <div className="max-w-2xl">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#EAB308] text-[#1A1D20] text-[11px] font-bold uppercase tracking-wider">
                Referenzanlage
              </div>
              <p className="mt-4 font-display font-semibold text-white text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-tight">
                12.6 kWp auf einem Bauernhaus im Emmental –
                <span className="text-white/70"> seit 2022 in Betrieb.</span>
              </p>
              <p className="mt-3 text-white/70 text-sm sm:text-base max-w-lg">
                Vollflächige Indach-Montage, 14 kWh Speicher, 82 % Eigenverbrauch.
              </p>
            </div>
          </figcaption>
        </motion.figure>
      </div>

      {/* Laufende Vertrauens-Leiste */}
      <div className="mt-10 border-y border-black/5 bg-white/70 py-4 overflow-hidden marquee-mask">
        <ul
          className="marquee-track flex items-center gap-10"
          data-testid="trust-marquee"
          aria-label="Zertifizierungen und Garantien"
        >
          {[...badges, ...badges].map((b, i) => {
            const Icon = b.icon;
            return (
              <li
                key={i}
                aria-hidden={i >= badges.length ? "true" : undefined}
                className="flex items-center gap-2.5 text-sm text-[#1A1D20]/75 whitespace-nowrap"
              >
                <Icon size={17} className="text-[#EAB308] shrink-0" />
                {b.label}
                <span className="ml-10 w-1 h-1 rounded-full bg-[#1A1D20]/20" />
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
